import React from 'react';
import PageHeader from '../shared/page-header';
import { Link } from 'react-router';
import { connect } from 'react-redux';

const Home = ({ builds }) => {

    const { version = '' } = builds.length > 0 ? {...builds[builds.length - 1]} : {};

    return (
        <div>
            <PageHeader><span><span>Claware: </span><span className="text-muted">Software for Culture and Language Acquisition</span></span></PageHeader>
            <div className="row">
                <div className="col-sm-12">
                    <div>
                        <div className="panel panel-success">
                            <div className="panel-heading">
                                <strong>Claware {version}</strong> is the current version of Claware
                            </div>
                            <div className="panel-body">
                                <p>How to obtain Claware:</p>
                                <ul>
                                    <li>From your field: Contact your field headquarters; each field received a Claware 3.83 DVD.</li>
                                    <li><Link to="/download/claware">Download Claware from this site</Link> (The download is very large; you must have a fast Internet connection.)</li>
                                    <li>Or <Link to="/contact">Contact Claware support</Link>.</li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <h2>Claware</h2>
                            <p>Claware is a software application specifically designed for efficiently filing, cross-referencing, retrieving, and analyzing the data gathered during the process of learning a new culture and language, enabling cross-cultural workers to spend less time managing their data and more time building relationships with people.</p>
                            <Link to="/download/claware"><button style={{minWidth: 200}} type="button" className="btn btn-primary"><i className="fa fa-download"></i> Download Claware</button></Link>
                        </div>
                        <div>
                            <h2>Map Creator</h2>
                            <p>Map Creator simplifies the creation of language-specific maps, charts, and diagrams for lessons and world geography.</p>
                            <a href="http://fmosoft.com/download"><button style={{minWidth: 200}} type="button" className="btn btn-primary"><i className="fa fa-download"></i> Download Map Creator</button></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
Home.propTypes = {
    builds: React.PropTypes.arrayOf(React.PropTypes.object)
};

const HomeContainer = connect(
    ({ appState }) => {
        return {
            builds: appState.builds
        };
    }
)(Home);

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/components/home/home.js